
export const resumeLink = 'https://arteben.github.io/'
export const picturesLink = '/img/pictures/'
export const linkToWorks = 'http://demosofgames.gt.tc/projects/'
